<script setup>
import { ref, onMounted, defineProps } from 'vue';

const props = defineProps({
    headerH: {
        type: Number,
        default: 0
    },
});

const pageNavList = ref([]); //ページナビのリスト

/**
 * ページナビを作成
 */
const createPageNav = () => {
    const targetList = document.querySelectorAll('.js-nav-target'); //対象要素を取得

    targetList.forEach(target => {
        const id = target.id; //idを取得
        const name = target.querySelector('.js-nav-tit').textContent; //タイトルを取得
        pageNavList.value.push({id, name}); //配列に格納
    });
}

onMounted(() => {
    createPageNav();
});

</script>

<template>
<nav class="page-nav">
    <a
    v-for="val in pageNavList"
    :key="val.id"
    v-scroll-to="{el: `#${val.id}`, offset: -headerH}"
    class="page-nav__item">{{ val.name }}</a>
</nav>
</template>